'use client'

import { Skeleton, RelativeTime } from '@yeshuman/sdk'
import { useApplicationCoverLetter } from '../../hooks/use-application-cover-letter'

export type ApplicationCoverLetterViewProps = {
  applicationId: string
  candidateName: string
}

export function ApplicationCoverLetterView({
  applicationId,
  candidateName,
}: ApplicationCoverLetterViewProps) {
  const { data, isLoading, error } = useApplicationCoverLetter(applicationId)

  if (isLoading) {
    return (
      <div className="mx-auto max-w-[65ch] space-y-3 py-6">
        <Skeleton className="h-4 w-48" />
        <Skeleton className="h-32 w-full" />
      </div>
    )
  }

  if (error || !data) {
    return (
      <p className="py-6 text-sm text-muted-foreground">Could not load the cover letter.</p>
    )
  }

  return (
    <article className="mx-auto max-w-[65ch] space-y-6 py-6">
      <p className="text-sm text-muted-foreground">
        Submitted with the application · <RelativeTime value={data.submitted_at} />
      </p>
      <div className="font-serif text-base leading-relaxed whitespace-pre-wrap text-foreground">
        {data.cover_letter}
      </div>
      <p className="font-serif text-sm text-muted-foreground">— {candidateName}</p>
    </article>
  )
}
